$(document).ready(function(){
    if (window.matchMedia("(max-width: 991px)").matches) {  

        var headerHeight = $('.logoNav').outerHeight();
        var searchFormHeight = parseInt("90px", 10);
        var searchResultPos = headerHeight + searchFormHeight;

        $('div.is-ajax-search-result').css({
            'top': searchResultPos,
            'height' : 'calc(100% - ' + searchResultPos+ 'px)'
        });

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');

            if($('.mobileSearch').hasClass('is-open')){
                $('.mobileSearch').toggleClass('is-open');
                $('body').toggleClass('search-expanded');
            };


        })

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).parent().toggleClass('is-selected');
        });

        // Ricerca
        $('.js-toggleSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').bind('touchmove', function(e){e.preventDefault()});
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };

            $('.mobileSearch').css({
                'top': headerHeight,
                'height' : 'calc(100% - ' + headerHeight+ 'px)'
            });

            $('div.is-ajax-search-result').css({
                'top' : searchResultPos,
                'height' : 'calc(100% - ' + searchResultPos+ 'px)'
            });

            $('.is-ajax-search-items').css({
                'height' : 'calc(100% - 50px)',
                'max-height' : 'calc(100% - 50px)'
            });


            if($('.announcement').hasClass('is-hidden')){
                $('.mobileSearch').css({
                    'top' : headerHeight,
                    'height' : 'calc(100% - ' + headerHeight+ 'px)'
                });
                $('div.is-ajax-search-result').css({
                    'top' : searchResultPos,
                    'height' : 'calc(100% - ' + searchResultPos+ 'px)'
                });

            };
        })


        $('.js-closeSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').unbind('touchmove');
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };
        })


        $('.js-openFilters').on('click',function(e){
            e.preventDefault();
            $('.filters').slideToggle();
            $('.openToggle').toggleClass('is-open');
        })





        /*     $('.btn-search').on('click',function(e){
            e.preventDefault();
                 $('.searchFormWrap', '.searchForm').show();
        })*/
    }

    // Sottomenu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
        

        // Lingue
        $('.js-dropdown').children('span').on('click', function(event){
            event.preventDefault();
            $(this).next('ul').toggle();
        });
        
    
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }

// Copy link
$('#buttonCopyText').on('click', function(event) {
    event.preventDefault();
    copyToClipboard();
});

function copyToClipboard() {
    var copyText = document.getElementById("inputCopyText");
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    document.execCommand("copy");

    $("#copyTextTooltip").css('display', 'inline');
document.execCommand("copy");
setTimeout( function() {
$("#copyTextTooltip").css('display', 'none');
}, 1000);

}


    
//Accordion

    $('.accordion .accordion__item.accordion__content').show();

    var item = document.querySelectorAll('.accordion__item');
    for(var i = 0; i < item.length; i++) {
        item[i].classList.add('js-item');
        //console.log(title[i].classList);
    }

    var title = document.querySelectorAll('.accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
        //console.log(title[i].classList);
    }

    var copy = document.querySelectorAll('.accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
        //console.log(copy[i].classList);
    }

    $('.accordion .js-content').slideUp();    
    $('.accordion__item .js-header').attr('aria-expanded','false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');



    //var $title = $('.accordion .js-header');

    $('.accordion .js-header').click(function () {
        $(this).next(copy).slideToggle();
        $(this).parent().siblings().children().next().slideUp();
        $(this).toggleClass('active');

        $(this).parent().siblings().children().removeClass('active');


        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }

    });

});
























/**************
     * Smooth anchor scroll
     */ 

$('a.anchor:not([href="#"])').on('click', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();

    // Fa ricalcolare a slick l'altezza, altrimenti lo slider presente nella tab nascosta risulta alto 0 e quindi non si vede
    //$('.slider-gallery').slick('setPosition');

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {

            // se scrolli con il mouse si interrompe lo smooth scroll
            $('html, body').bind('mousewheel', function(e){ 
                $(this).stop();
            });

            $('html').animate({
                scrollTop: target.offset().top 
            }, 600);

            /*$('html, body').animate({
                    scrollTop: target.offset().top -130
                }, 1000);*/

            return false;
        }
    }
});



$(document).ready(function(){
    if (window.location.hash) {
        var myAnchor = $(window.location.hash);
        if (myAnchor.length > 0) {
            var myOffset = 70;

            if (myAnchor.hasClass('js-header')) {
                myAnchor.click();
                myOffset = 150;
            }

            $('html, body').animate({
                scrollTop: myAnchor.offset().top - myOffset
            }, 100);

            return false;
        }
    }
});



// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


$(document).ready(function(){

    // Read more
    $('.js-more').on('click',function(e){
        e.preventDefault();
        $(this).next('div').slideToggle('slow');
        $(this).text($(this).text() == 'Leggi di più' ? 'Leggi meno' : 'Leggi di più');
    })


    $('header .js-header').click(function () {
        $(this).next(copy).toggle();
        $(this).parent().siblings().children().next().hide();
        $(this).toggleClass('active');

        $(this).parent().siblings().children().removeClass('active');


        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });



});



/**************
* Quantity
*/ 

$(document).on('click', '.quantity .plus', function(e) {
    e.preventDefault();

    // Read current quantity
    var qtyInput = $(this).parent().find('[type="number"].qty');
    var currQty = parseInt(qtyInput.val());

    // Updated quantity
    var newQty = currQty + 1;

    // Update inputs
    qtyInput.val(newQty).change();

});

$(document).on('click', '.quantity .minus', function(e) {
    e.preventDefault();

    // Read current quantity
    var qtyInput = $(this).parent().find('[type="number"].qty');
    var currQty = parseInt(qtyInput.val());

    // If there's at least 1 item
    if (currQty > 0) {
        // Updated quantity
        var newQty = currQty - 1;

        // Update inputs
        qtyInput.val(newQty).change();

    }
});

    // Loading su aggiunta al carrello
    $(".button-loading-wrap ").click(function(event){
        event.preventDefault();
        $(".view-cart").css('opacity','0');
        $(".button-loading-wrap").removeClass("cart-is-updated");
        $(this).addClass("loading");


        setTimeout(function() {
            $(".button-loading-wrap").removeClass("loading").addClass("cart-is-updating");
            // For failed icon just replace ".done" with ".failed"
            //$(".done").addClass("finish");
        }, 2000);

        setTimeout(function() {
            $(".view-cart").css('opacity','1');
            $(".button-loading-wrap").removeClass("cart-is-updating").addClass("cart-is-updated");
            //$(".done").removeClass("finish");
            //$(".failed").removeClass("finish");
        }, 4000);
    })

$(document).ready(function(){
    $('.multiple-items').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,  
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

/* Store the window width */
var windowWidth = $(window).width();

/* Resize Event */
$(window).resize(function(){
    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() != windowWidth) {

        // Update the window width for next time
        windowWidth = $(window).width();

        setTimeout(function(){
            window.location.reload();
        });

    }
});
 
